<template>
  <div class="rn-card box-card-style-default card-list-view">
    <div class="inner">
      <div class="thumbnail">
        <router-link v-if="blog.type==='2'" class="image" :to="{path:'/news-details',query:{id:blog.newsId}}" target="_blank">
          <img style="height: 120px;object-fit: cover;" v-if="blog.thumbUrl" class="w-100" :src="blog.thumbUrl" :alt="blog.title">
          <img style="height: 120px;object-fit: cover;" v-else class="w-100" :src="require('@/assets/images/blog/blog-logo.jpg')" :alt="blog.title">
        </router-link>
        <my-router-link v-if="blog.type==='1'" class="image" :to="blog.url" target="_blank">
          <img style="height: 120px;object-fit: cover;" v-if="blog.thumbUrl" class="w-100" :src="blog.thumbUrl" :alt="blog.title">
          <img style="height: 120px;object-fit: cover;" v-else class="w-100" :src="require('@/assets/images/blog/blog-logo.jpg')" :alt="blog.title">
        </my-router-link>
      </div>
      <div class="content" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">

        <h4 class="title" >
          <template>
            <router-link v-if="blog.type==='2'" :to="{path:'/news-details',query:{id:blog.newsId}}" target="_blank">
              {{ blog.title }}
            </router-link>
            <my-router-link v-if="blog.type==='1'" :to="blog.url" target="_blank">
              {{ blog.title }}
            </my-router-link>
          </template>
        </h4>
        <ul  class="rn-meta-list">
          <li>
            <router-link :to="''">
              {{ blog.author }}
            </router-link>
          </li>
          <li class="separator">/</li>
          <li>{{ blog.newsDate }}</li>
        </ul>
<!--        <p  class="descriptiion">
          {{ blog.digest }}
        </p>-->
      </div>
    </div>
  </div>
</template>

<script>
import MyRouterLink from "../../components/common/MyRouterLink";
export default {
  name: 'BlogPost',
  components:{MyRouterLink},
  props: {
    blog: {},
    blogPostStyle: {
      type: String,
      default: 'card'
    }
  }
}
</script>